module.exports = __webpack_public_path__ + "static/media/da-ct-scan-2.c7bd3dc9.jpg";